import React, { ImgHTMLAttributes } from 'react'

interface LogoProps extends ImgHTMLAttributes<HTMLImageElement> {}

const Logo: React.FC<LogoProps> = ({ className, ...props }) => {
  return <img src="/assets/logo_2x.png" alt="Flowbite React Logo" className={`h-24 ${className}`} {...props} />
}

export default Logo
